import { FC } from 'react';
import Icon from '@common/assets';
import classnames from 'classnames/bind';
import styles from './tooltip.module.scss';
const cx = classnames.bind(styles);

interface TooltipProps {
  content: React.ReactNode;
}

const Tooltip: FC<TooltipProps> = (props) => {
  const { content } = props;
  return (
    <a className={cx('tooltipArea')} role="button">
      <Icon name="informationLight" fill={'#fff'} width={20} height={20} />
      <div className={cx('tooltip')}>{content}</div>
    </a>
  );
};

export default Tooltip;
